// extracted by mini-css-extract-plugin
module.exports = {"input":"TripsModule_input__1TgSc","actions":"TripsModule_actions__3HdeI","table":"TripsModule_table__1NCbm"};